import type Wei from '@kwenta/wei'

export function isWeiEqual(l: Wei, r: Wei): boolean {
	return l.eq(r)
}
